import React from 'react';
import ReactDOM from 'react-dom';
import { translate } from 'react-i18next';

import timepicker from 'vendor/timepicker.js';

class UnavailablesPartialDatePicker extends React.Component {
  constructor(props) {
    super(props);

    this.startTimepicker;
    this.endTimepicker;

    this.handleClick = this.handleClick.bind(this);
    this.state = {
      startDate: null,
      startsAt: '',
      endsAt: '',
    };
  }

  componentDidMount() {
    var that = this;

    that.initDatePickers();

    that.resetInputs();

    // Using Event Listener instead of react way of onChange={..} because timepicker.js
    // doesn't trigger a change event when updating the time
    document
      .getElementById('request-start')
      .addEventListener('change', that.setStartsAt.bind(this), false);
    document
      .getElementById('request-end')
      .addEventListener('change', that.setEndsAt.bind(this), false);
  }

  componentWillMount() {
    document.addEventListener('mousedown', this.handleClick, false);
  }

  componentWillUnmount() {
    var that = this;

    document.removeEventListener('mousedown', that.handleClick, false);

    document
      .getElementById('request-start')
      .removeEventListener('change', that.setStartsAt.bind(this), false);
    document
      .getElementById('request-end')
      .removeEventListener('change', that.setEndsAt.bind(this), false);
  }

  componentWillReceiveProps() {
    this.resetInputs();
  }

  // Reset displayed input values of datepickers
  resetInputs() {
    ReactDOM.findDOMNode(this).querySelector('input#request-start').value = '';
    ReactDOM.findDOMNode(this).querySelector('input#request-end').value = '';
  }

  handleClick(e) {
    const { start } = this.refs;
    const { end } = this.refs;

    // Hide start time picker if clicking outside
    if (!this.refs.start.contains(e.target)) {
      this.startTimepicker.active = false;
    }

    // Hide end time picker if clicking outside
    if (!this.refs.end.contains(e.target)) {
      this.endTimepicker.active = false;
    }
  }

  initDatePickers() {
    const args = {
      format: true,
      meridiem: false,
      increment: 5,
    };

    this.endTimepicker = new timepicker(document.querySelector('input#request-end'), args);
    this.startTimepicker = new timepicker(document.querySelector('input#request-start'), args);
  }

  // Update parent's state: startsAt
  setStartsAt() {
    const startDate = this.buildDate(
      this.props.date,
      this.startTimepicker.getTime(),
      Utils.getCoreUser().inferred_time_zone,
    );

    this.props.startsAtHandler(startDate);
    this.props.partialHandler(true);

    // Make sure to update endsAt too to account for when the startsAt time
    // crosses over the endsAt time (i.e: +/- a day)
    if (this.props.endsAt) this.setEndsAt();
  }

  // Update parent's state: endsAt
  setEndsAt() {
    let endsAt = this.buildDate(
      this.props.date,
      this.endTimepicker.getTime(),
      Utils.getCoreUser().inferred_time_zone,
    );

    // Account for times that cross the midnight line
    if (endsAt <= this.props.startsAt) endsAt = moment(endsAt).add(1, 'days')._d;

    this.props.endsAtHandler(endsAt);
    this.props.partialHandler(true);
  }

  // Builds a date in a specific time zone
  //
  // The reason this approach is taken is because timepicker always returns a time
  // with today's date. So we need to reconstruct a date with the correct date, hours, and zone.
  buildDate(date, time, zone) {
    let hours = `${time.getHours()}`;
    let minutes = `${time.getMinutes()}`;

    if (hours.length < 2) hours = `0${hours}`;
    if (minutes.length < 2) minutes = `0${minutes}`;

    return moment.tz(`${this.formatDate(date)}T${hours}:${minutes}`, zone).toDate();
  }

  // Returns a date in the format YYYY-MM-DD
  formatDate(date) {
    const d = new Date(date);
    let month = `${d.getMonth() + 1}`;
    let day = `${d.getDate()}`;
    const year = d.getFullYear();

    if (month.length < 2) month = `0${month}`;
    if (day.length < 2) day = `0${day}`;

    return [year, month, day].join('-');
  }

  // Returns hours formatted in a user/location's time zone
  formatHours(time) {
    if (time == null) return '';

    return moment(time)
      .tz(Utils.getCoreUser().inferred_time_zone)
      .format('h:mm a');
  }

  render() {
    // Note:
    // The lines "onChange={() => { return null }}" are because react expects
    // an onChange function if you're also setting the value prop of an input.
    // However in our case we're leveraging a JQuery library so everything is
    // different (and broken). To deal with the error, just use an onChange
    // callback that returns null.

    return (
      <div className="form-field-group">
        <div className="form-group-item" ref="start">
          <label htmlFor="timeoff-start-date">{this.props.t('UnavailablesPartialDatePicker.start_time')}</label>
          <div className="time">
            <input
              id="request-start"
              placeholder={this.props.t('UnavailablesPartialDatePicker.start')}
              className="timepicker"
              name="start-time"
              value={this.formatHours(this.props.startsAt)}
              onChange={() => null}
            />
          </div>
        </div>
        <div className="form-group-item" ref="end">
          <label htmlFor="timeoff-end-date">{this.props.t('UnavailablesPartialDatePicker.end_time')}</label>
          <input
            id="request-end"
            placeholder={this.props.t('UnavailablesPartialDatePicker.end')}
            className="timepicker"
            name="end-time"
            value={this.formatHours(this.props.endsAt)}
            onChange={() => null}
          />
        </div>
      </div>
    );
  }
}

export default translate()(UnavailablesPartialDatePicker);
